<app-product *ngIf="product" [product]="product" [similarProducts]="similarProducts"
             [interestedInProducts]="interestedInProducts"></app-product>
<app-alert-error [error]="error" [routeToHomepage]="true" [showAppLogo]="true"></app-alert-error>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

